import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject, Subscription, timer} from 'rxjs';
import {TranslatedFile, TranslationModel, TranslationSupportiveLanguage} from '../../../models/translation.model';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {MatDialogRef} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {switchMap, takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {TranslationService} from '../../../services/translation.service';
import {FileManagementService} from '@core/services/file-management.service';
import {TranslationStatus} from '../../../models/translation.constants';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';

@Component({
    standalone: false,
    selector: 'particle-select-translation-language',
  templateUrl: './select-translation-language.component.html',
  styleUrls: ['./select-translation-language.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectTranslationLanguageComponent implements OnInit, IDialogView, OnDestroy, AfterViewInit {
  data: DialogModel;
  supportiveLanguageQueryKey = 'TranslationSupportiveLanguage';
  unsubscribe$ = new Subject<void>();
  isFileScanned: boolean;
  toLanguage: string;
  fromLanguage: string;
  translationSupportiveLanguage: TranslationSupportiveLanguage[] = [];
  private language$: any;
  translationId: string;
  fileId: string;
  showAddTranslationWindow = false;
  translationModel: TranslationModel = null;
  translationStatuses = TranslationStatus;
  @ViewChild('dynamicComponent', {read: ViewContainerRef}) viewContainerRef;
  fileName: string;
  private componentInstance: any = null;
  showNoSuccessFullTranslationMessage = false;
  private subscription: Subscription;

  constructor(private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileManagementService: FileManagementService,
              private translationService: TranslationService,
              public dialogRef: MatDialogRef<SelectTranslationLanguageComponent>,
              private componentFactoryResolver: ComponentFactoryResolver,
              private changeDetector: ChangeDetectorRef,
              private queryStore: Store<IQueryState>) {
    this.isFileScanned = false;
    this.fromLanguage = null;
    this.toLanguage = null;
    this.translationId = '';
  }


  ngOnInit() {
    this.language$ = this.queryStore.pipe(select(getQueryResponse, this.supportiveLanguageQueryKey), takeUntil(this.unsubscribe$));
    this.language$ = this.queryStore.pipe(select(getQueryResponse, this.supportiveLanguageQueryKey), takeUntil(this.unsubscribe$));
    this.language$.subscribe(language => {
      if (language) {
        this.translationSupportiveLanguage = language;
        if (this.translationSupportiveLanguage && this.translationSupportiveLanguage.length > 0) {
          this.translationSupportiveLanguage = this.translationService.sortTranslationSupportiveLanguage(this.translationSupportiveLanguage);
        }
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.supportiveLanguageQueryKey, {});
    this.fileId = this.data.input.fileId;
    this.fileName = this.data.input.fileName;
    this.translationId = this.data.input.translationId;
    this.getTranslationsModel();
  }

  onOkClicked(): boolean {
    if (this.showAddTranslationWindow && this.componentInstance) {
      if (this.componentInstance.onOkClicked()) {
        this.data.input.formConfig = this.componentInstance.data.input.formConfig;
        console.log('formConfig:', this.data.input.forConfig);
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private closeDialog() {
    this.dialogRef.close({
      action: 'OK',
      data: this.data
    });
  }

  ngAfterViewInit(): void {
  }

  private getTranslationsModel() {
    this.fuseSplashScreenService.show();
    this.translationService.getTranslatinModel(this.translationId).pipe(takeUntil(this.unsubscribe$)).subscribe(translationModel => {
      this.fuseSplashScreenService.hide();
      this.processTranslationModel(translationModel);
    });
  }

  private autoFetchTranslation() {
    const intervalPeriod = 10 * 1000;
    this.subscription = timer(0, intervalPeriod).pipe(
      switchMap(() => {
          return this.translationService.getTranslatinModel(this.translationId);
        }
      ),
      takeUntil(this.unsubscribe$)
    ).subscribe(translationModel => {
      this.translationModel = translationModel;
      if (!this.translationModel) {
        this.snackBarService.showError('Translation model not found!');
      }
    } ,err => {
      this.snackBarService.showError('Translation model fetching failed!');
    });
  }


  private processTranslationModel(translationModel: TranslationModel | any) {
    console.log('translationModel:', translationModel);
    this.translationModel = translationModel;
    if (!this.translationModel) {
      this.translationId = '';
      this.showAddTranslationWindow = true;
      this.showNoSuccessFullTranslationMessage = true;
      setTimeout(() => {
        this.renderAddTranslationWindow('TranslationSettingComponent');
      }, 50);
      this.data.okCaption = 'Translate';
    } else {
      this.showAddTranslationWindow = false;
      if (!translationModel.translatedFiles || translationModel.translatedFiles.length === 0) {
        this.showNoSuccessFullTranslationMessage = true;
      }
      if (this.translationModel.status === this.translationStatuses.Queued || this.translationModel.status === this.translationStatuses.InProgress) {
        this.showNoSuccessFullTranslationMessage = false;
      }
      this.data.okCaption = 'Done';
      this.autoFetchTranslation();
    }
  }

  onOpenTranslatedFile(translatedFile: TranslatedFile) {
    this.data.input.openFileId = translatedFile.fileId;
    this.data.input.openFileContentId = translatedFile.fileContentId;
    this.closeDialog();
  }

  onAddTranslation() {
    this.showAddTranslationWindow = true;
    setTimeout(() => {
      this.renderAddTranslationWindow('TranslationSettingComponent');
    }, 50);
    this.data.okCaption = 'Translate';
  }

  private renderAddTranslationWindow(componentName: string = 'TranslationSettingComponent') {
    this.changeDetector.detectChanges();
    this.componentInstance = null;
    const resolvedComponent = <Type<any>>RootDynamicComponentHelper.getComponent(componentName);
    this.viewContainerRef.clear();
    const component = this.viewContainerRef.createComponent(resolvedComponent);
    this.componentInstance = component.instance;
    this.componentInstance.data = {
      input: {
        isDriveForm: true,
        translationId: this.translationId,
        fileId: this.fileId,
        fileName: this.fileName
      }};
  }

  onOpenOriginalFile() {
    this.data.input.openFileId = this.fileId;
    this.data.input.pdfType = 'original';
    this.closeDialog();
  }
}





